var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuirn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.5,617.8V47.4h60.95v251.86l151.8-152.95,43.7,43.7-157.55,156.39,157.55,157.56-42.55,43.69-152.95-152.94v223.09c41.39,7.67,75.89,28.19,103.48,61.53s41.41,72.25,41.41,116.72c0,49.83-17.25,92.38-51.75,127.66-34.5,35.25-75.91,52.89-124.2,52.89s-89.69-17.64-124.19-52.89c-34.5-35.28-51.75-77.83-51.75-127.66,0-44.47,13.8-83.38,41.39-116.72s62.48-53.86,104.66-61.53ZM566.63,880.59c22.61-23.39,33.92-51.56,33.92-84.53s-11.31-61.14-33.92-84.52c-22.62-23.38-50.03-35.08-82.23-35.08s-59.61,11.7-82.22,35.08c-22.62,23.38-33.92,51.55-33.92,84.52s11.3,61.14,33.92,84.53c22.61,23.36,50.02,35.06,82.22,35.06s59.61-11.7,82.23-35.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuirn);
export default __webpack_public_path__ + "static/media/Quirón.d462c55a74f90a95f01ba650c07ea47f.svg";
export { ForwardRef as ReactComponent };